import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";

const WithdrawAffiliate = () => {
  const token = Cookies.get("token");

  const [withdraws, setWithdraws] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [balance, setBalance] = useState(0);
  const [totalCommission, setTotalCommission] = useState(0);
  const [totalWithdraw, setTotalWithdraw] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const [selectedWithdraw, setSelectedWithdraw] = useState<any>(null);
  const [showDetail, setShowDetail] = useState(false);

  const formatPrice = (price: any) => {
    return new Intl.NumberFormat("id-ID").format(price);
  };

  /*
  ============================
  GET BALANCE
  ============================
  */

  const fetchBalance = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/affiliate/balance`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setBalance(res.data.balance);
      setTotalCommission(res.data.total_commission);
      setTotalWithdraw(res.data.total_withdraw);
    } catch (err) {
      console.log(err);
    }
  };

  /*
  ============================
  GET WITHDRAW LIST
  ============================
  */

  const fetchWithdraws = async (page = 1) => {
    setLoading(true);

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/affiliate/withdrawals?page=${page}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setWithdraws(res.data.data);

      setCurrentPage(res.data.current_page);
      setLastPage(res.data.last_page);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBalance();
    fetchWithdraws();
  }, []);

  return (
    <div className="mt-7">
      {/* SUMMARY */}
      <div className="flex justify-end items-center mb-5">
        <Link to={"/dashboard-affiliate/withdraw/tambah"}>
          <button className="bg-primary text-white px-11 py-2 rounded-lg">+ Ajukan Withdraw</button>
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <div className="bg-white border rounded-xl p-5 shadow">
          <p className="text-sm text-gray-500">Saldo Saat Ini</p>
          <h2 className="text-2xl font-bold text-green-600">Rp {formatPrice(balance)}</h2>
        </div>

        <div className="bg-white border rounded-xl p-5 shadow">
          <p className="text-sm text-gray-500">Total Komisi</p>
          <h2 className="text-2xl font-bold">Rp {formatPrice(totalCommission)}</h2>
        </div>

        <div className="bg-white border rounded-xl p-5 shadow">
          <p className="text-sm text-gray-500">Total Withdraw</p>
          <h2 className="text-2xl font-bold text-red-500">Rp {formatPrice(totalWithdraw)}</h2>
        </div>
      </div>

      {/* TABLE */}
      <div className="bg-white rounded-xl shadow border w-full">
        <div className="overflow-x-auto">
          <table className="min-w-[700px] w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 text-left">Bank</th>
                <th className="p-3 text-left">Rekening</th>
                <th className="p-3 text-left">Nama</th>
                <th className="p-3 text-left">Nominal</th>
                <th className="p-3 text-left">Tanggal</th>
                <th className="p-3 text-left">Status</th>
                <th className="p-3 text-left">Aksi</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={7} className="text-center p-10">
                    Loading...
                  </td>
                </tr>
              ) : withdraws.length > 0 ? (
                withdraws.map((withdraw) => (
                  <tr key={withdraw.id} className="border-t">
                    <td className="p-3">{withdraw.bank_name}</td>

                    <td className="p-3">{withdraw.account_number}</td>

                    <td className="p-3">{withdraw.account_name}</td>

                    <td className="p-3 font-semibold">Rp {formatPrice(withdraw.amount)}</td>

                    <td className="p-3">{new Date(withdraw.created_at).toLocaleString("id-ID")}</td>

                    <td className="p-3">
                      {withdraw.status === "approved" && <span className="bg-green-100 text-green-600 px-2 py-1 rounded text-xs">Approved</span>}

                      {withdraw.status === "pending" && <span className="bg-yellow-100 text-yellow-600 px-2 py-1 rounded text-xs">Pending</span>}

                      {withdraw.status === "rejected" && <span className="bg-red-100 text-red-600 px-2 py-1 rounded text-xs">Rejected</span>}
                    </td>

                    <td className="p-3">
                      <div
                        onClick={() => {
                          setSelectedWithdraw(withdraw);
                          setShowDetail(true);
                        }}
                        className="text-blue-500 cursor-pointer">
                        <FaEye size={18} />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-center p-10">
                    Tidak ada data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* PAGINATION */}
      <div className="flex justify-end gap-3 mt-5">
        <button disabled={currentPage === 1} onClick={() => fetchWithdraws(currentPage - 1)} className="px-4 py-2 bg-gray-200 rounded">
          Prev
        </button>

        <span>
          {currentPage} / {lastPage}
        </span>

        <button disabled={currentPage === lastPage} onClick={() => fetchWithdraws(currentPage + 1)} className="px-4 py-2 bg-gray-200 rounded">
          Next
        </button>
      </div>

      {/* DETAIL MODAL */}
      {showDetail && selectedWithdraw && (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-[420px] max-w-[95%]">
            <div className="bg-primary text-white px-6 py-4">
              <h2 className="text-lg font-semibold">Detail Withdraw</h2>
            </div>

            <div className="p-6 space-y-3 text-sm">
              <p>
                <b>Bank:</b> {selectedWithdraw.bank_name}
              </p>

              <p>
                <b>Nomor Rekening:</b> {selectedWithdraw.account_number}
              </p>

              <p>
                <b>Nama Rekening:</b> {selectedWithdraw.account_name}
              </p>

              {selectedWithdraw.status !== "rejected" && (
                <p>
                  <b>Nominal:</b> Rp {formatPrice(selectedWithdraw.amount)}
                </p>
              )}

              <p>
                <b>Status:</b> {selectedWithdraw.status}
              </p>

              {selectedWithdraw.reject_reason && (
                <p className="text-red-500">
                  <b>Alasan Reject:</b> {selectedWithdraw.reject_reason}
                </p>
              )}
            </div>

            <div className="px-6 py-4 border-t flex justify-between">
              <a href="https://wa.me/62895352380652" target="_blank" rel="noopener noreferrer" className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600">
                Hubungi Admin
              </a>

              <button onClick={() => setShowDetail(false)} className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300">
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WithdrawAffiliate;
